import { SnackbarProvider } from "notistack";
import PropTypes from "prop-types";
import React from "react";
import { StyledEngineProvider, ThemeProvider } from "@mui/material/styles";

import theme from "apps/providers/theme";

export default function MUIProvider({ children, snackbar }) {
    return (
        <ThemeProvider theme={theme}>
            <StyledEngineProvider injectFirst>
                {snackbar ? (
                    <SnackbarProvider
                        hideIconVariant
                        anchorOrigin={{
                            vertical: "bottom",
                            horizontal: "center",
                        }}
                    >
                        {children}
                    </SnackbarProvider>
                ) : (
                    children
                )}
            </StyledEngineProvider>
        </ThemeProvider>
    );
}

MUIProvider.propTypes = {
    snackbar: PropTypes.bool,
};

MUIProvider.defaultProps = {
    snackbar: false,
};
